"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const array_1 = __importDefault(require("@powerednow/shared/modules/utilities/array"));
const bluebird_1 = __importDefault(require("bluebird"));
const action_1 = __importDefault(require("@powerednow/shared/constants/action"));
const demoJob_1 = __importDefault(require("@powerednow/shared/constants/demoJob"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const date_1 = require("@powerednow/shared/modules/utilities/date");
const constants_1 = require("@powerednow/shared/constants");
const textUtils_1 = __importDefault(require("@powerednow/shared/modules/utilities/textUtils"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
const projectItemNames = {
    note: 'note',
    action: 'action',
    mediaGroup: 'mediaGroup',
    media: 'media',
    jobItemGroup: 'jobItemGroup',
    document: 'document',
    documentAction: 'documentAction',
    signature: 'signature',
    timeLog: 'timeLog',
    message: 'message',
    archiveBatch: 'archiveBatch',
    formDocument: 'formDocument',
    customerMessage: 'customerMessage',
    fileGroup: 'fileGroup',
};
// eslint-disable-next-line no-redeclare
class Job extends complexData_1.default {
    static get allowedAssociations() {
        return {
            jobStats: {
                key: 'jobStats',
                instance: (0, modelLookup_1.complexFindModel)('JobStats'),
                single: true,
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            customer: {
                key: 'customer',
                instance: (0, modelLookup_1.complexFindModel)('Customer'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().customer_id,
                },
            },
            appointment: {
                key: 'action',
                instance: (0, modelLookup_1.complexFindModel)('Action'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                    type: action_1.default.ACTION_TYPES.ACTION_TYPE_APPOINTMENT,
                },
            },
            site: {
                key: 'contactToAddress',
                instance: (0, modelLookup_1.complexFindModel)('ContactToAddress'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().site_id,
                },
            },
            note: {
                key: 'note',
                instance: (0, modelLookup_1.complexFindModel)('Note'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            action: {
                key: 'action',
                instance: (0, modelLookup_1.complexFindModel)('Action'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            mediaGroup: {
                key: 'mediaGroup',
                instance: (0, modelLookup_1.complexFindModel)('MediaGroup'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            jobItemGroup: {
                key: 'jobItemGroup',
                instance: (0, modelLookup_1.complexFindModel)('JobItemGroup'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            document: {
                key: 'document',
                instance: (0, modelLookup_1.complexFindModel)('Document'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            purchaseOrder: {
                key: 'document',
                instance: (0, modelLookup_1.complexFindModel)('Document'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                    type: constants_1.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER,
                },
            },
            documentAction: {
                key: 'documentAction',
                instance: (0, modelLookup_1.complexFindModel)('DocumentAction'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            signature: {
                key: 'signature',
                instance: (0, modelLookup_1.complexFindModel)('Signature'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            timeLog: {
                key: 'timeLog',
                instance: (0, modelLookup_1.complexFindModel)('TimeLog'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            message: {
                key: 'message',
                instance: (0, modelLookup_1.complexFindModel)('Message'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            formDocument: {
                key: 'formDocument',
                instance: (0, modelLookup_1.complexFindModel)('FormDocument'),
                cascadeDelete: false,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            customerMessage: {
                key: 'customerMessage',
                instance: (0, modelLookup_1.complexFindModel)('CustomerMessage'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            company: {
                key: 'company',
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                single: true,
                condition: {
                    company_id: this.Entity.getFieldSymbols().company_id,
                },
            },
            fileGroup: {
                key: 'fileGroup',
                instance: (0, modelLookup_1.complexFindModel)('FileGroup'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            archiveBatch: {
                key: 'archiveBatch',
                instance: (0, modelLookup_1.complexFindModel)('ArchiveBatch'),
                cascadeDelete: false,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
            media: {
                key: 'media',
                instance: (0, modelLookup_1.complexFindModel)('Media'),
                cascadeDelete: true,
                condition: {
                    job_id: this.Entity.getFieldSymbols().id,
                },
            },
        };
    }
    static get indexedSearchConfig() {
        return {
            customer: true,
            site: true,
        };
    }
    async findSite() {
        const site = await this.getSite();
        if (!site) {
            return (await this.getCustomer()).getMainContactToAddress();
        }
        return site;
    }
    hasAnyItem() {
        return array_1.default.someAsync(this.getProjectItemAssociationNames(), async (assocName) => (await this.getAssociatedValueCount(assocName, [])) > 0);
    }
    async getItems() {
        return array_1.default.mergeAsync(this.getProjectItemAssociationNames().filter(assocName => Boolean(assocName)), assocName => (this.getAssociatedValue(assocName)));
    }
    getProjectItemAssociationNames() {
        return [
            projectItemNames.note,
            projectItemNames.customerMessage,
            projectItemNames.action,
            projectItemNames.mediaGroup,
            projectItemNames.jobItemGroup,
            projectItemNames.document,
            projectItemNames.documentAction,
            projectItemNames.signature,
            projectItemNames.timeLog,
            projectItemNames.message,
        ];
    }
    async addPayment(payment) {
        const stats = await this.getJobStats();
        let total = payment.data.amount;
        if (stats && stats.data.invoice_payments) {
            total += stats.data.invoice_payments;
        }
        await this.setStats({ invoice_payments: total });
    }
    async getConfirmedDocuments() {
        return (await this.getAllDocument()).filter(document => document.data.confirmed);
    }
    async getTotals() {
        const totals = {
            quoted: 0,
            accepted: 0,
            invoiced: 0,
            invoiced_exVat: 0,
            supplier_invoiced: 0,
            supplier_invoiced_exVat: 0,
            invoice_payments: 0,
            supplier_invoice_payments: 0,
            projected_profit: 0,
            projected_profit_exVat: 0,
            outstanding_invoice_payments: 0,
            outstanding_supplier_invoice_payments: 0,
        };
        await bluebird_1.default.each(this.getConfirmedDocuments(), async (document) => {
            const totalAdjustments = await document.getDocumentTotals();
            Object.entries(totalAdjustments).forEach(([key, value]) => {
                totals[key] += value;
            });
        });
        Object.entries(totals).forEach(([key, value]) => {
            totals[key] = Math.abs(value);
        });
        return {
            ...totals,
            outstanding_invoice_payments: totals.invoiced - totals.invoice_payments,
            outstanding_supplier_invoice_payments: totals.supplier_invoiced - totals.supplier_invoice_payments,
            projected_profit: totals.invoiced - totals.supplier_invoiced,
            projected_profit_exVat: totals.invoiced_exVat - totals.supplier_invoiced_exVat,
        };
    }
    async getTimeLogStats() {
        const logRecords = await this.getAllTimeLog();
        const totalTime = logRecords.reduce((subTotal, logRecord) => subTotal + logRecord.data.time, 0);
        return { totalTime };
    }
    async getVisibleTimelineItems() {
        const unFilteredTimelineItems = await this.getItems();
        return unFilteredTimelineItems.filter(item => (!('is_hidden' in item.data) || !item.data?.is_hidden));
    }
    isDemoJob() {
        return this.data.dt_created === demoJob_1.default.dt_created && this.data.customer_id === demoJob_1.default.customer_id;
    }
    async setStats(newValue) {
        const stats = await this.getJobStats();
        if (!stats) {
            return this.setJobStats({
                company_id: this.data.company_id,
                job_id: this.data.id,
                ...newValue,
            });
        }
        Object.assign(stats.data, newValue);
        return stats;
    }
    async updateTotals() {
        const totals = await this.getTotals();
        const timeTotals = await this.getTimeLogStats();
        return this.setStats({
            ...totals,
            ...timeTotals,
        });
    }
    async createDocument(params) {
        const company = await this.getCompany();
        const parentDocument = await this.getDocumentById(params.parentId);
        const walkMap = {
            NewDocumentClone: {
                JobItemGroup: [(0, modelLookup_1.complexFindModel)('JobItem')],
                JobItem: [(0, modelLookup_1.complexFindModel)('MediaGroup')],
                MediaGroup: [(0, modelLookup_1.complexFindModel)('Media')],
            },
        };
        const newProperties = {
            is_hidden: true,
            dt_created: (0, date_1.getNow)(),
            use_tax: company.data.vat_registered,
            is_inclusive: (params.documentType === constants_1.DOCUMENT.TYPES_VALUES.EXPENSE || params.documentType === constants_1.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE ? company.data.tax_inclusive_expense : company.data.tax_inclusive) ? 1 : 0,
        };
        const { suffixMap } = params;
        const documentItems = params.useExistingItems
            ? params.items
            : await bluebird_1.default.map(params.items, async (item) => {
                const result = await item.deepCopy({ walkMap: walkMap.NewDocumentClone, parent: this, newProperties });
                if (suffixMap) {
                    suffixMap[result.data.id] = suffixMap[item.data.id];
                    delete suffixMap[item.data.id];
                }
                if (params.taxUpdateNeeded && result.getDocumentItemType() === constants_1.DOCUMENT.DOCUMENT_ITEMS.TYPES.JOB_ITEM_GROUP) {
                    await result.saveCurrentTaxSettingsRecursively();
                }
                return result;
            });
        const pricedItemCount = documentItems.filter(item => item instanceof (0, modelLookup_1.complexFindModel)('JobItemGroup')).length;
        const displayTotal = pricedItemCount > 1 || (constants_1.DOCUMENT.IS_FINANCIAL[params.documentType] && pricedItemCount === 0);
        const customer = params.supplier || await this.getCustomer();
        const dt_created = (0, date_1.getNow)();
        const newDocument = await this.addDocument({
            company_id: company.data.id,
            dt_created,
            taxpoint: params.taxpoint,
            status: params.status,
            job_id: this.data.id,
            customer_id: customer.data.id,
            user_id: params.user.data.id,
            type: params.documentType,
            layout_id: params.layoutId,
            uuid: textUtils_1.default.generateUniqueId(),
            displaynumber: constants_1.DOCUMENT.DEFAULT_DISPLAY_NUMBER,
            header: company.getHeader(params.documentType),
            footer: company.getFooter(params.documentType),
            display_total: displayTotal,
            is_cis: (customer.data.cis_enabled && company.data.cis_enabled) && (params.documentType === constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE || params.documentType === constants_1.DOCUMENT.TYPES_VALUES.INVOICE),
            plot: params.plot,
            dueDate: params.documentType === constants_1.DOCUMENT.TYPES_VALUES.INVOICE ? company.getDueDate(new Date(dt_created)) : '',
            refusereason: params.refusereason,
            site_id: params.siteId,
            template_path: params.templatePath,
            is_disbursement: params.isDisbursement,
        });
        await newDocument.addDocumentItems(documentItems, params.suffixMap);
        await newDocument.calculate();
        await newDocument.updateSummary();
        if (parentDocument) {
            await newDocument.setParent(parentDocument);
            if (parentDocument.data.accounting_reference === constants_1.INTEGRATION.ACCOUNTING_REFERENCE_NO_SYNC) {
                newDocument.data.accounting_reference = constants_1.INTEGRATION.ACCOUNTING_REFERENCE_NO_SYNC;
            }
        }
        return newDocument;
    }
}
Job.Entity = entity_1.default;
Job.modelProperties = modelProperties_1.default;
exports.default = Job;
//# sourceMappingURL=../../../../src/models/job/index.js.map